import React from 'react';
import { ResponsiveSankey } from '@nivo/sankey';
import '../SankeyChart/SankeyChart.css';

const SankeyChart = () => {
  // Extended data for the Sankey chart with more share market related nodes and links
  const data = {
    nodes: [
      { id: 'Investors' },
      { id: 'Tech Stocks' },
      { id: 'Energy Stocks' },
      { id: 'Retail Stocks' },
      { id: 'Financial Stocks' },
      { id: 'Market Cap Growth' },
      { id: 'Stock Decline' },
      { id: 'Institutional Investors' },
      { id: 'Retail Investors' },
      { id: 'Small-Cap Stocks' },
      { id: 'Large-Cap Stocks' },
      { id: 'Dividend Stocks' },
      { id: 'Growth Stocks' },
    ],
    links: [
      { source: 'Investors', target: 'Tech Stocks', value: 40 },
      { source: 'Investors', target: 'Energy Stocks', value: 25 },
      { source: 'Investors', target: 'Retail Stocks', value: 15 },
      { source: 'Investors', target: 'Financial Stocks', value: 20 },
      { source: 'Tech Stocks', target: 'Market Cap Growth', value: 30 },
      { source: 'Energy Stocks', target: 'Stock Decline', value: 10 },
      { source: 'Retail Stocks', target: 'Stock Decline', value: 15 },
      { source: 'Tech Stocks', target: 'Stock Decline', value: 10 },
      { source: 'Institutional Investors', target: 'Tech Stocks', value: 50 },
      { source: 'Retail Investors', target: 'Energy Stocks', value: 10 },
      { source: 'Small-Cap Stocks', target: 'Stock Decline', value: 5 },
      { source: 'Large-Cap Stocks', target: 'Market Cap Growth', value: 35 },
      { source: 'Dividend Stocks', target: 'Market Cap Growth', value: 20 },
      { source: 'Growth Stocks', target: 'Market Cap Growth', value: 25 },
    ],
  };

  return (
    <div className='sankey-container'>
      <h2>Market Flow Analysis</h2>
      <ResponsiveSankey
        height={450}
        data={data}
        margin={{ top: 40, right: 160, bottom: 70, left: 50 }}
        align="justify"
        colors={['#28a745', '#dc3545']}  // Green and Red color scheme
        nodeOpacity={1}
        nodeHoverOthersOpacity={0.35}
        nodeThickness={18}
        nodeSpacing={24}
        nodeBorderWidth={0}
        nodeBorderColor={{
          from: 'color',
          modifiers: [['darker', 0.8]],
        }}
        nodeBorderRadius={3}
        linkOpacity={0.5}
        linkHoverOthersOpacity={0.1}
        linkContract={3}
        enableLinkGradient={true}
        labelPosition="outside"
        labelOrientation="vertical"
        labelPadding={16}
        labelTextColor={{
          from: 'color',
          modifiers: [['darker', 1]],
        }}
        legends={[
          {
            anchor: 'bottom-right',
            direction: 'column',
            translateX: 130,
            itemWidth: 100,
            itemHeight: 14,
            itemDirection: 'right-to-left',
            itemsSpacing: 2,
            itemTextColor: '#999',
            symbolSize: 14,
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#000',
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default SankeyChart;
